import { v4 as uuidv4 } from "uuid";

const SESSION_ID_KEY = "ui-client-log:session-id";
let memorySessionId: string | undefined;

export const getSessionId = (): string => {
  try {
    const stored = window.sessionStorage.getItem(SESSION_ID_KEY);
    if (stored) return stored;
    const created = memorySessionId ?? uuidv4();
    window.sessionStorage.setItem(SESSION_ID_KEY, created);
    memorySessionId = created;
    return created;
  } catch {
    memorySessionId = memorySessionId ?? uuidv4();
    return memorySessionId;
  }
};

export const getStoreNumber = (): string => {
  try {
    return window.localStorage.getItem("storeId") || "UNKNOWN";
  } catch {
    return "UNKNOWN";
  }
};
